module.exports = __webpack_public_path__ + "media/images/menu_izq/usuario-90b7de16901296bbcd1d7d7b72342088.svg";